<script lang="ts">
	import Card from '$lib/components/Card.svelte';
	import Search from '$lib/components/Search.svelte';
	import Section from '$lib/components/Section.svelte';
	import { debounce } from '$lib/utils/debounce';
	import { flip } from 'svelte/animate';
	import { quintOut } from 'svelte/easing';
	import { crossfade } from 'svelte/transition';

	let { data } = $props();

	let posts = $derived(data.posts);

	const [send, receive] = crossfade({
		duration: (d) => Math.sqrt(d * 200),
		fallback: (nodes, params) => {
			return {
				duration: 200,
				easing: quintOut,
				css: (t) => `opacity: ${t}`
			};
		}
	});
</script>

<Section>
	<h1>Blog</h1>
	<p class="mb-4 text-gray-800 dark:text-gray-300">
		Here you can find all of the latest posts from the blog.
	</p>
	<Card>
		<p class="mb-4 text-gray-800 dark:text-gray-300">Search Posts by title</p>
		<Search
			class="w-full"
			placeholder="E.g. SvelteKit is awesome"
			oninput={debounce((value: string) => {
				if (value) {
					posts = data.posts.filter((post) =>
						post.title.toLowerCase().includes(value.toLowerCase())
					);
				} else {
					posts = data.posts;
				}
				posts = posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
			}, 200)}
		></Search>
	</Card>
</Section>

<Section class="space-y-4">
	{#each posts as post (post.slug)}
		<div
			animate:flip={{ duration: 200 }}
			in:send={{ duration: 200, key: post.slug }}
			out:receive={{ duration: 200, key: post.slug }}
		>
			<Card>
				<h2 class="mb-4">
					<a
						href={`/blog/${post.slug}`}
						class="text-gray-800 no-underline hover:text-gray-700 hover:underline dark:text-gray-100 dark:hover:text-gray-50"
						>{post.title}</a
					>
				</h2>
				<figure class="mx-auto mt-2 mb-4 max-w-2/3">
					<img
						src={`/blog/${encodeURIComponent(post.slug)}.png`}
						alt={post.title}
						class="rounded-lg"
						width="800"
						height="420"
					/>
				</figure>
				<time class="text-sm tracking-tighter">{new Date(post.date).toLocaleDateString()}</time>
				<p class="mb-2">{post.description}</p>
				{#if post.tags}
					<ul class="flex flex-wrap gap-2">
						{#each post.tags as tag}
							<li>
								<a
									href="/blog/tags/{tag}"
									class="rounded border-[1px] border-gray-400 bg-gray-300 px-2 py-1 text-xs text-gray-800 no-underline hover:bg-gray-200 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 hover:dark:bg-gray-700 dark:hover:text-gray-100"
								>
									{tag}
								</a>
							</li>
						{/each}
					</ul>
				{/if}
			</Card>
		</div>
	{:else}
		<div in:send={{ duration: 200, key: null }} out:receive={{ duration: 200, key: null }}>
			<Card class="w-full max-w-2xl mx-auto">
				<h2>No posts found</h2>
				<p class="mb-2">No posts match your search.</p>
				<p class="mb-2">Try searching for something else.</p>
			</Card>
		</div>
	{/each}
</Section>
